
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { fetchReview } from '~/fc/Dal/UtilityRepo'
import { LoaderIcon } from 'vue-feather-icons'

export default {
    name: 'TrustPilotReviews',
    components: {
        VueSlickCarousel, LoaderIcon,
        SectionFullwidthBackground: () => import('../../layouts/partials/sections/SectionFullwidthBackground.vue'),
        BlockStarIcon: () => import('./icon/BlockStarIcon'),
        CarouselNextIcon: () => import('./icon/CarouselNextIcon'),
        RoundCheckIcon: () => import('./icon/RoundCheckIcon'),
        TrustPilotIcon: () => import('./icon/TrustPilotIcon')
    },
    props: {
        reviews: {
            default: () => ([]),
            required: true
        },
        collapsed: {
            default: false
        }
    },
    data: () => ({
        averageRating: 4.6,
        totalRating: '15000+',
        windowWidth: 0,
        translationLoading: false,
        showArrows: false,
        sliderMounted: false
    }),
    computed: {
        selectedLocale() {
            return this.$i18n.locales.find(
                locale => this.$i18n.locale === locale.code
            )
        },
        slidesToShow() {
            if (this.windowWidth <= 768) {
                return 1
            }
            if (this.windowWidth <= 991) {
                this.collapsed ? 1 : 2
            }
            if (this.windowWidth <= 1200) {
                return this.collapsed ? 2 : 3
            }
            return this.collapsed ? 3 : 4
        },
        settings() {
            return {
                arrows: false,
                dots: false,
                focusOnSelect: true,
                infinite: true,
                speed: 500,
                slidesToShow: this.slidesToShow,
                slidesToScroll: 1,
                touchThreshold: this.slidesToShow,
                draggable: !!this.showArrows
            }
        }
    },
    created() {
        this.showArrows = this.reviews.length > this.slidesToShow
    },
    mounted() {
        this.windowWidth = window.innerWidth
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
        })
        this.$nextTick(() => {
            this.sliderMounted = true
        })
    },
    methods: {
        showNext() {
            this.$refs.carousel.next()
        },
        showPrev() {
            this.$refs.carousel.prev()
        },
        async translate(id, index, translate) {
            this.translationLoading = index
            const data = await fetchReview(this, id, translate)
            this.reviews[index].title = data.title
            this.reviews[index].content = data.content
            this.reviews[index].code = data.code ? data.code : null
            this.translationLoading = false
        },
        stopPropagation(e) {
            e.stopPropagation()
        },
        parseInt(int) {
            return parseInt(int)
        }
    }
}
